// 9fbef606107a605d69c0edbcd8029e5d
const EMAIL_SIGNUP_CONSTANTS = {
  VALIDATE_EMAIL: 'VALIDATE_EMAIL',
  EMAIL_VALIDATION_STATUS: 'EMAIL_VERIFICATION_STATUS',
  EMAIL_SUBSCRIPTION_SUBMIT: 'EMAIL_SUBSCRIPTION_SUBMIT',
  EMAIL_SUBSCRIPTION_STATUS: 'EMAIL_SUBSCRIPTION_STATUS',
  CLEAR_SMS_SUBSCRIPTION_FORM: 'CLEAR_SMS_SUBSCRIPTION_FORM',
  SMS_SUBSCRIPTION_SUBMIT: 'SMS_SUBSCRIPTION_SUBMIT',
  SMS_SUBSCRIPTION_STATUS: 'SMS_SUBSCRIPTION_STATUS',
  SMS_DISCLAIMER_MODULEX_KEY: 'SmsDisclaimer',
};

export default EMAIL_SIGNUP_CONSTANTS;
